import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import WhatsAppWidget from "pages/homepage/components/WhatsAppButton";
import TravelerStoriesHub from "./pages/traveler-stories-hub";
import StoryDetail from "./pages/traveler-stories-hub/StoryDetail";
import TrekDiscoveryHub from "./pages/trek-discovery-hub";

import SherpaGuideProfiles from "./pages/sherpa-guide-profiles";
import SherpaGuideDetail from "./pages/sherpa-guide-profiles/SherpaGuideDetail";
import TrekPackageDetails from "./pages/trek-package-details";
import Homepage from "pages/homepage";
import BookingConsultationCenter from "pages/booking-consulation-center";

// New imports
import ActivitiesHub from "./pages/activities-hub";
import ActivityDetail from "./pages/activity-detail";
import NepalVisaInformation from "./pages/nepal-visa-information";
import TravelInformation from "./pages/travel-information";
import GettingToNepal from "./pages/getting-to-nepal";
import WeatherClimate from "./pages/weather-climate";
import ShoppingEntertainment from "./pages/shopping-entertainment";
import NepalFAQ from "./pages/nepal-faq";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <WhatsAppWidget />
        <RouterRoutes>
          {/* Trekking */}
          <Route path="/trek-discovery-hub" element={<TrekDiscoveryHub />} />
          <Route
            path="/trek-discovery-hub/:trekId"
            element={<TrekPackageDetails />}
          />

          {/* Guides */}
          <Route path="/sherpa-guide-profiles" element={<SherpaGuideProfiles />} />
          <Route
            path="/sherpa-guide-profiles/:guideId"
            element={<SherpaGuideDetail />}
          />

          {/* Stories */}
          <Route path="/traveler-stories-hub" element={<TravelerStoriesHub />} />
          <Route
            path="/traveler-stories-hub/:storyId"
            element={<StoryDetail />}
          />

          {/* Activities & Experiences */}
          <Route path="/activities" element={<ActivitiesHub />} />
          <Route path="/activities/:activityId" element={<ActivityDetail />} />

          {/* Nepal Info Pages */}
          <Route path="/nepal-visa-information" element={<NepalVisaInformation />} />
          <Route path="/travel-information" element={<TravelInformation />} />
          <Route path="/getting-to-nepal" element={<GettingToNepal />} />
          <Route path="/weather-climate" element={<WeatherClimate />} />
          <Route path="/shopping-entertainment" element={<ShoppingEntertainment />} />
          <Route path="/nepal-faq" element={<NepalFAQ />} />

          {/* Booking */}
          <Route
            path="/booking-consultation-center"
            element={<BookingConsultationCenter />}
          />

          {/* Home */}
          <Route path="/" element={<Homepage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
